import AttendanceAdapter from './base';

export default class MovementCode extends AttendanceAdapter {
  modelNamePlural = 'movementCodes';
}
